module.exports = __webpack_public_path__ + "static/img/yiSwiper.c5b92cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yiSwiper.jpg
// module id = nYbJ
// module chunks = 0